export default function (slotId, slotType, slotFamily, rate) {
    const slot = {
        id: slotId,
        type: slotType,
        family: slotFamily,
        outcomes: []
    };

    slot.condition = rate ? rate.get('value') : 1;

    return slot;
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/factories/CustomSlotFactory.js